






























































import Vue from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';

import moment from 'moment';
import { Transition } from '@/models/transition';
import { ErrorManager } from '@/models/error';
import ErrorAlert from '../common/ErrorAlert.vue';
import PayrollChangeRequestStatusDisplay from '../requisition-common/PayrollChangeRequestStatusDisplay.vue';
import { PayrollChangeRequestStatus, IPayrollChangeRequest } from '@/models';
import ALDialog from '../core/Dialog/ALDialog.vue';

export default Vue.extend({
  components: { ErrorAlert, PayrollChangeRequestStatusDisplay, ALDialog },
  data: () => ({
    dialog: false,
    loading: false,

    errorMessage: '',
    detailErrorMessage: '',

    headers: [
      {
        text: 'Date',
        align: 'start',
        sortable: false,
        value: 'timestamp'
      },
      {
        text: 'Changed By',
        align: 'start',
        sortable: false,
        value: 'user'
      },
      {
        text: 'Previous State',
        align: 'center',
        sortable: false,
        value: 'source_state'
      },
      {
        text: 'Current State',
        align: 'center',
        sortable: false,
        value: 'state'
      }
    ]
  }),

  computed: {
    payrollChangeRequestActivities: get<Transition[]>(
      'payrollChangeRequest/getPayrollChangeRequestActivities'
    )
  },

  methods: {
    moment,

    ...mapActions({
      fetchPayrollChangeRequestActivities:
        'payrollChangeRequest/fetchPayrollChangeRequestActivities'
    }),

    payrollChangeRequestStatusFromValue(value: number) {
      const requestStatus = new PayrollChangeRequestStatus({
        value: Number(value)
      });
      return requestStatus;
    },

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    open(payrollChangeRequest: IPayrollChangeRequest) {
      this.clearAllErrors();

      this.dialog = true;
      this.loading = true;

      this.fetchPayrollChangeRequestActivities(payrollChangeRequest.id)
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    close() {
      this.dialog = false;
    }
  }
});
